/**
 * Created by PuTi(编程即菩提) 2/19/17.
 */
var list = require('./model/list');
module.exports = function (inNb) {
    var opts = inNb.opts;
    var $ = opts.$;
    var seq = 1;
    var eventSeq = 1;
    var Model = inNb.Model = inNb.extend(inNb.NBType, {
        method: {
            init: function () {
                var self = this;
                var parent = this.parent;
                var parentMapping = parent ? parent.prototype.mapping : null;
                var mapping = this.__nb_model_mapping = this.mapping || {};
                this.__nb_event_map = {};
                this.__nb_props = {};
                this.__nb_instanceId = this.getSequence();

                if (parentMapping && mapping) {
                    $.each(parentMapping, function (inKey, inValue) {
                        var type = mapping[inKey];
                        if (!type) {
                            type = mapping[inKey] = inValue;
                        }
                    });
                }
                $.each(mapping, function (inName, inType) {
                    if (inType.prototype instanceof inNb.NBType) {
                        var model = new inType;
                        self.set(inName, model);
                    }
                });
            },
            getSequence: function () {
                return seq++;
            },
            setOpts: function (inOpts) {
                var self = this;
                if (inOpts) {
                    $.each(inOpts, function (inName, inValue) {
                        self.set(inName, inValue);
                    });
                }
            },
            set: function (inName, inValue) {
                var mapping = this.__nb_model_mapping;
                var mappingType = mapping[inName];
                var props = this.__nb_props;
                var eventMap = this.__nb_event_map;
                var events = eventMap[inName] || {};
                var prop = props[inName] = props[inName] || {};
                var data;
                var value = inValue;
                var isList = false;
                var model, eventList, result;

                eventList = events['before'];
                if (eventList) {
                    $.each(eventList, function (inIndex, inEvent) {
                        result = inEvent.fn.call(inEvent.scope, {origin: prop.origin, data: value}, value);
                        if (result != undefined) {
                            value = result;
                        }
                    });
                }

                //use type to create mode instance
                if (!(value instanceof inNb.NBType) && mappingType) {
                    if (prop && (data = prop.data)) {
                        if(data instanceof inNb.NBType){
                            data.setOpts(value);
                            return;
                        }
                        value = data;
                    } else {
                        if (mappingType.prototype instanceof inNb.NBType) {
                            model = new mappingType();
                            model.setOpts(value);
                        } else {
                            model = mappingType.call(this, value);
                        }
                        value = model;
                    }
                }

                prop.origin = prop.data;
                prop.data = value;
                eventList = events['after'];
                //TODO
                if (value instanceof inNb.model.List) {
                    isList = true;
                }
                //TODO skip same value support?
                if (eventList) {
                    $.each(eventList, function (inIndex, inEvent) {
                        if(inEvent){
                            inEvent.fn.call(inEvent.scope, prop, value);
                        }
                    });
                }
            },
            get: function (inName) {
                var props = this.__nb_props || {};
                var prop = props[inName];
                return prop == undefined ? null : prop.data;
            },
            onChange: function (inName, inFn, inScope, inOpts) {
                var eventMap = this.__nb_event_map;
                var opts = inOpts || {};
                var events = eventMap[inName];
                var before = opts.before;
                var type = before ? 'before' : 'after';
                var once = opts.once;
                var prop = this.__nb_props[inName];
                var id = eventSeq++;
                var event = {
                    id: id,
                    scope: inScope,
                    fn: inFn,
                    opts: opts
                };
                var eventList;
                if (!events) {
                    eventMap[inName] = events = {};
                }
                eventList = events[type];
                if (!eventList) {
                    events[type] = eventList = [];
                }
                eventList.push(event);
                if (prop && !inNb.opts.mixRender) {
                    inFn.call(inScope, prop, prop.data);
                    if (once) {
                        return;
                    }
                }
                return id;
            },
            offChange: function (inId) {
                if (!inId) {
                    return;
                }
                $.each(this.__nb_event_map, function (inKey, inEventType) {
                    $.each(inEventType, function (inType, inEventList) {
                        $.each(inEventList,function (inIndex,inEvent) {
                            if (inEvent && inEvent.id == inId) {
                                inEventList[inIndex] = null;
                            }
                        });
                    });
                });
            }
        }
    });
    inNb.model = new Model();
    list(inNb);
};


//////////////////
// WEBPACK FOOTER
// ../src/nb/core/js/core/model.js
// module id = 211
// module chunks = 35